// Decode a JWT's payload without verifying the signature. The token is
// already verified server-side by the Cognito JWT authorizer; the SPA only
// reads claims for display/identification.

interface JwtClaims {
  sub?: string;
  exp?: number;
  iat?: number;
  [key: string]: unknown;
}

export function decodeJwtClaims(token: string): JwtClaims | null {
  const parts = token.split(".");
  if (parts.length !== 3) return null;
  const payload = parts[1];
  if (!payload) return null;
  try {
    const padded = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padLength = (4 - (padded.length % 4)) % 4;
    const decoded = atob(padded + "=".repeat(padLength));
    return JSON.parse(decoded) as JwtClaims;
  } catch {
    return null;
  }
}
